<core-loading [hideUntil]="dataLoaded" [fullscreen]="false">
    <core-compile-html [text]="content" [javascript]="javascript" [jsData]="jsData" [forceCompile]="forceCompile" #compile />
</core-loading>
